import Vue, { VueConstructor } from 'vue';
import generatedApi from './generated/generatedApi';

const loadApi = () => ({
  core: {
    ...generatedApi(),
  },
  // Add custom apis here
  // persons: { ...personsServices(Vue.$service) },
});

export default {
  install: (VuePlugin: VueConstructor, options: any) => {
    VuePlugin.$guards.waitForAppLoad().then(() => {
      const otherApi = VuePlugin.$service.api ?? {};
      VuePlugin.$service.api = { ...loadApi(), ...otherApi };
    });
  },
};

export type CoreServiceAPI = ReturnType<typeof loadApi>;
